import { http } from '../util/https.util';

const START_LINK_URL = '/api/microsoft/link';

export namespace MicrosoftRequest {
  export const startLink = async (payload: {}): Promise<string> => {
    const response = await http.post(START_LINK_URL, payload);
    return response.data;
  };
}
